import { RequestMainService } from '../request'

export class RwaService {
  static async getRwaEntitlement(params: any = {}) {
    return RequestMainService.get(`/admin/rwa-entitlement`, params).then(({ result }) => ({
      count: result.total,
      data: result.data,
      totalRwa: result?.totalRwa,
    }))
  }
}
